import './Footer.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Logo } from '@assets/images/logo.svg';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="modFooter">
      <div className="modFooter__section">
        <a className="modText modText--body2 modText--link" href="#">
          {t('footer.terms')}
        </a>
      </div>
      <div className="modFooter__section modFooter__section--highlighted">
        <p className="modText modText--body2">
          {t('footer.poweredBy')} <Logo className="modFooterLogo" />
        </p>
      </div>
      <div className="modFooter__section">
        <p className="modText modText--body2">
          {t('footer.questions')}{' '}
          <a className="modText modText--link modText--underline" href="https://modulate.ca/#Contact">
            {t('footer.contactUs')}
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
